// Versioned schemas for AthenaEvents. When the schema evolves, a new schema
// version is added.
export const athenaEventSchemaV0 = {
    version: 0,
    primaryKey: "id",
    type: "object",
    properties: {
        // The primary key must have set maxLength
        id: { type: "string", maxLength: 100 },
        type: { type: "string" },
        createdAt: { type: "string" },
        insertedAt: { type: "string" },
        userId: { type: "string" },
        sessionId: { type: "string" },
        app: { type: "string" },
        categoryData: { type: "object" },
        data: { type: "object" },
    },
    required: [
        "id",
        "type",
        "createdAt",
        "userId",
        "sessionId",
        "categoryData",
        "data",
    ],
};
//# sourceMappingURL=athenaEventSchema.js.map